import { render, staticRenderFns } from "./tagClass.vue?vue&type=template&id=1b25af42&scoped=true&"
import script from "./tagClass.vue?vue&type=script&lang=js&"
export * from "./tagClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b25af42",
  null
  
)

export default component.exports